import { initCategorySettings, initEnvironmentCategorySettings } from '../../actions'
import { Dispatch, ExtraArgs, GetState } from '../../../../types'
import { ARMServer } from '../../../../remote-api/models'
/**
 *  Action Constants
 */

export const Loading = 'Monitoring/Settings/Hybrid/Loading';
export const DownloadedInstaller = 'Monitoring/Settings/Hybrid/DownloadedInstaller';
export const ChangeSelectedServer = 'Monitoring/Settings/Hybrid/ChangeSelectedServer';
export const ChangeSelectedServerGroup = 'Monitoring/Settings/Hybrid/ChangeSelectedServerGroup';
export const FetchServers = 'Monitoring/Settings/Hybrid/FetchServers';
export const ChangeServers = 'Monitoring/Settings/Hybrid/ChangeServers';
export const ChangeAgentInstallerUrl = 'Monitoring/Settings/Hybrid/AgentInstaller';

/**
 *  Action Type
 */
export type LoadingAction = {
  type: 'Monitoring/Settings/Hybrid/Loading'
}

export type FetchServersAction = {
  type: 'Monitoring/Settings/Hybrid/FetchServers'
}

export type DownloadedInstallerAction = {
  type: 'Monitoring/Settings/Hybrid/DownloadedInstaller'
}

export type ChangeSelectedServerAction = {
  type: 'Monitoring/Settings/Hybrid/ChangeSelectedServer'
  payload: {
    selectedServer: string
  }
}

export type ChangeSelectedServerGroupAction = {
    type: 'Monitoring/Settings/Hybrid/ChangeSelectedServerGroup'
    payload: {
        selectedServerGroup: string
    }
}
export type ChangeServersAction = {
  type: 'Monitoring/Settings/Hybrid/ChangeServers'
  payload: {
    servers: ARMServer[]
  }
}

export type ChangePatchSettingsAction = {
  type: 'Monitoring/Settings/Hybrid/ChangePatchSettingsStatus'
  payload: string
}

export type ChangeAgentInstallerUrlAction = {
  type: 'Monitoring/Settings/Hybrid/AgentInstaller'
  payload: {
    publicUrl: string
  }
}

/**
 *  Action Creators
 */
export const initializeLoadingAction = (): LoadingAction => ({
  type: Loading,
});

export const initializeLoading = () => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
  dispatch(initializeLoadingAction());
};

export const initializeFetchServersAction = (): FetchServersAction => ({
  type: FetchServers,
});

export const initializeFetchServers = () => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
  dispatch(initializeFetchServersAction());
};

export const downloadedInstallerAction = (): DownloadedInstallerAction => ({
  type: DownloadedInstaller,
});

export const downloadedInstaller = () => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
  dispatch(downloadedInstallerAction());
};

export const changeSelectedServerAction = (selectedServer: string): ChangeSelectedServerAction => ({
  type: ChangeSelectedServer,
  payload: {selectedServer: selectedServer}
});

export const changeSelectedServerGroupAction = (selectedServer: string): ChangeSelectedServerGroupAction => ({
    type: ChangeSelectedServerGroup,
    payload: { selectedServerGroup: selectedServer }
});

export const selectServer = (serverId: string) => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
  dispatch(changeSelectedServerAction(serverId));
};

export const selectServerGroup = (serverId: string) => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
    dispatch(changeSelectedServerGroupAction(serverId));
};

export const changeServersAction = (servers: ARMServer[]): ChangeServersAction => ({
  type: ChangeServers,
  payload: {servers}
});

export const fetchServers = (orgId: string, envId: string) => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
  dispatch(initializeFetchServers());
  return api.arm(getState).fetchServers(orgId, envId).then((result: any) => {
    dispatch(changeServersAction(result.data));
  });
};

export const fetchAmZipUrl = () => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
    return api.ui(getState).fetchAgentInstallerUrl().then((resp: { url: string }) => {
        dispatch(changeAgentInstallerUrl(resp.url))
    });
};

export const changeAgentInstallerUrl = (publicUrl: string): ChangeAgentInstallerUrlAction => ({
    type: ChangeAgentInstallerUrl,
    payload: {publicUrl}
});

export const changeLocalStorageSettingsEnv = (environmentId: string) => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
  const enrichedCategory = dispatch(initCategorySettings('hybrid'))
  dispatch(initEnvironmentCategorySettings(enrichedCategory, environmentId))
};

export type SettingsHybridActions =
  | LoadingAction
  | DownloadedInstallerAction
  | ChangeSelectedServerAction
  | FetchServersAction
  | ChangeServersAction
  | ChangePatchSettingsAction
  | ChangeAgentInstallerUrlAction
  | ChangeSelectedServerGroupAction
